import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getCategoryPosts } from "../api/WordPressAPI";
import LearningCenter from "../components/modules/LearningCenter";
import Template from "../components/templates/Template";
import { updatePosts } from "../redux/slices/appSlice";
import ReactGA from "react-ga4";

// WordPress category ID for "PAO Tutorials" (confirmed via
// /wp-json/wp/v2/categories on wp-api.cadsoft.com).
const PAO_TUTORIALS_CATEGORY_ID = 20;

const AppContainer = (props) => {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.app.posts);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  // initialize ga4 analytics, if a measurement ID has been configured for
  // this app (leave REACT_APP_GA4_MEASUREMENT_ID unset to skip).
  useEffect(() => {
    const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
    if (measurementId) {
      ReactGA.initialize(measurementId);
    }
  }, []);

  // Fetches posts from WordPress under Category "PAO Tutorials".
  useEffect(() => {
    getCategoryPosts(PAO_TUTORIALS_CATEGORY_ID)
      .then((res) => {
        const data = res.data.sort((a, b) => a?.date - b?.date).reverse();
        dispatch(updatePosts(data));
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(err.message);
        setIsLoading(false);
      });

    return () => {
      dispatch(updatePosts([]));
      setErrorMessage("");
    };
  }, [dispatch]);

  return (
    <Template>
      <Box
        sx={{ display: "flex", flex: 1, flexDirection: "column", flexGrow: 1 }}
      >
        {posts.length > 0 ? (
          <Routes>
            <Route path="/article/:id" element={<LearningCenter />} />
            <Route
              path="*"
              element={<Navigate to={`/article/${posts[0].id}`} replace />}
            />
          </Routes>
        ) : (
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {isLoading ? (
              <CircularProgress color="secondary" />
            ) : (
              <Typography>{errorMessage}</Typography>
            )}
          </Box>
        )}
      </Box>
    </Template>
  );
};

export default AppContainer;
